exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 896px) {\n.subscription-carrier-fee-pending-block[data-v-69be9d44]{\n      max-width: 1080px;\n}\n}\n@media screen and (max-width: 895px) {\n.subscription-carrier-fee-pending-block[data-v-69be9d44]{\n    width:95%;\n}\n}\n", ""]);

// exports
